export default {
    LOW: 33,
    MID: 66,
    HIGH: 100,
};
